/* template */
<template minapp="mpx" xlang="wxml"><div class="coupon-card-container" v-if="(isShowCardFrame)"><card-frame :class="(cardFrameClass)" :cardConf="(couponCardConf)"><coupon-item :couponData="(couponData)" class="coupon-item"/></card-frame></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2528d0d7"}'>
  .coupon-card-container
    background #fff
    border-radius 8px
    margin 10px auto
    .card-title
      border-radius 8px
      background #FFF6F1
      box-sizing border-box
      border 1.5px solid #fff
    .coupon-item
      margin-top 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2528d0d7"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2528d0d7%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2528d0d7%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2528d0d7"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2528d0d7/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'card-frame':getComponent(require("../../../../components/card-frame/index.mpx?isComponent&outputPath=components%2Findexf4806b60%2Findex")),'coupon-item':getComponent(require("./coupon-item.mpx?isComponent&outputPath=components%2Fcoupon-item38c6ec42%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
